export enum InterfaceEventNameLocal {
  EmbeddedWalletCreated = 'Embedded Wallet Created',
  PortfolioMenuOpened = 'Portfolio Menu Opened',
  UniswapXOrderDetailsSheetOpened = 'UniswapX Order Details Sheet Opened',
  UniswapXOrderCancelInitiated = 'UniswapX Order Cancel Initiated',
  UniswapXSignatureRequested = 'UniswapX Signature Requested',
  UniswapXSignatureDeadlineExpired = 'UniswapX Signature Deadline Expired',
  UniswapXOrderPostError = 'UniswapX Order Post Error',
  UniswapXOrderSubmitted = 'UniswapX Order Submitted',
  LimitPresetRateSelected = 'Limit Preset Rate Selected',
  LimitPriceReversed = 'Limit Price Reversed',
  LimitExpirySelected = 'Limit Expiry Selected',
  SwapTabClicked = 'Swap Tab Clicked',
  LocalCurrencySelected = 'Local Currency Selected',
  NoQuoteReceivedFromQuickrouteAPI = 'No quote received from quickroute API',
  NoQuoteReceivedFromRoutingAPI = 'No quote received from routing API',
  CreatePositionFailed = 'Create Position Failed',
  IncreaseLiquidityFailed = 'Increase Liquidity Failed',
  DecreaseLiquidityFailed = 'Decrease Liquidity Failed',
  MigrateLiquidityFailed = 'Migrate Liquidity Failed',
  CollectLiquidityFailed = 'Collect Liquidity Failed',
  LimitedWalletSupportToastShown = 'Limited Wallet Support Toast Shown',
  LimitedWalletSupportToastDismissed = 'Limited Wallet Support Toast Dismissed',
  LimitedWalletSupportToastLearnMoreButtonClicked = 'Limited Wallet Support Learn More Button Clicked',
  WalletCapabilitiesDetected = 'Wallet Capabilities Detected',
}
